import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react';
import ProviderManager from '../../../provider/providerManager';
import Loader from '../LocalLoader/LocalLoader';
import alert from './images/alert.svg';

const UploadFile = (props) => {
  const [fileName, setFileName] = useState('');
  const [uploadFileErrorMsg, setUploadFileErrorMsg] = useState('');
  const [validationFileErrorMsg, setValidationFileErrorMsg] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSendFileSuccess, setIsSendFileSuccess] = useState(false);
  const maxSizeInKB = 20 * 1024; // 20 MB in KB
  
  async function uploadFile(e) {
    const file = e.target.files[0];
    const fileName = file.name.split('.')[0];
    setFileName(fileName);
    const fileExtension = file.type.split('/')[1];
    const fileSizeInBytes = file.size;
    const fileSizeInKB = fileSizeInBytes / 1024;
    let base64Converted = await toBase64(file);
    const base64ConvertedWithoutType = base64Converted.replace(`data:${file.type};base64,`, "");
    const isValidFile = validateFile(fileExtension , fileSizeInKB);
    if(isValidFile){
      const fileType = getExtensionType(fileExtension);
      sendFile(base64ConvertedWithoutType, fileType);
    }
  }

  const getExtensionType = (extension) => {
    switch (extension) {
      case 'png':
        return 1;
      case 'jpg':
        return 2;
      case 'jpeg':
        return 3;
      case 'txt':
        return 4;
      case 'pdf':
        return 5;
      case 'doc':
        return 6;
      case 'docx':
        return 7;
      case 'csv':
        return 8;
      default:
        return '';
    }
  }

  const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

  async function sendFile(base64Converted , fileType ) {
      try {
        setIsLoading(true);
        setUploadFileErrorMsg('');
        const params = {
          fileStream: base64Converted,
          fileType: fileType,
          phoneNumber: props.phoneNumber,
          codeFile: props.codeFile,
        };

        const result = await ProviderManager.getProviderData('uploadIdfVerificationFile', params);
        result.Body.isSuccess && setIsSendFileSuccess(true);
        !result.Body.isSuccess && setUploadFileErrorMsg('הקובץ אינו תקין') && setIsSendFileSuccess(false);

        return result?.Body;
      } catch (error) {
        setIsSendFileSuccess(false);
        setUploadFileErrorMsg('שגיאה - שלח שוב');
      } finally {
        setIsLoading(false);
      }
  }

  function validateFile(fileExtension , fileSize) {
    const isValidFileExtension = fileExtension == "pdf" || fileExtension == "jpg" || fileExtension == "jpeg" || fileExtension == "png";
    const isValidFileSize = fileSize <= maxSizeInKB;
    if(!isValidFileExtension){
      setValidationFileErrorMsg('אנא טען קובץ pdf\\jpg\\jpeg\\png בלבד');
      return false;
    }
    if (!isValidFileSize) {
      setValidationFileErrorMsg('לא ניתן לטעון קובץ. הקובץ גדול מ-20MB');
      return false;
    }
    setValidationFileErrorMsg('');
    return true;
  }

  return (
    <div className='upload-file-wrapper'>
      <div className='info'><span className='icon-info' style={{backgroundImage:alert.bg()}}/><span className='text' dangerouslySetInnerHTML={{ __html: props.text }} ></span></div>
      <div className='description'>באפשרותך להעלות מסמכים במשקל של עד 20MB <br/>בפורמטים: pdf, jpg, jpeg, png</div>
      {isSendFileSuccess ? <span className='upload-file-success-msg'><Image src={require('./images/send-success.svg')} alt='' />התקבל קובץ</span> :
        <div className='file-input-wrapper'>
            <input type='file' name='fileInput' id="fileInput" accept=".pdf, .jpg, .jpeg, .png , heif, heic"
            hidden
            onChange={(e) => {
              uploadFile(e);
            }} />
            <label className='upload-file' htmlFor='fileInput'>
            <Image src={require('./images/upload-icon.svg')} alt='upload-icon' /> העלאת צילום תעודה
            </label>
        </div>
      }
      <div className='error-wrapper'>
        {validationFileErrorMsg && <span className='validation-file-msg'>{validationFileErrorMsg}</span>}
        {!uploadFileErrorMsg && isLoading ?
          <Loader /> :
          <span className='upload-file-error-msg'>{uploadFileErrorMsg}</span>
        }
      </div>
    </div>
  );
};
export default UploadFile;
